import { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { getClientAppointmentList, updateClientAppointment, deleteClientAppointment } from "../slice/clientPanelAppointmentSlice";

const ClientBookAppointment = () => {

    const dispatch = useDispatch();
    const { clientsAppointment, loading } = useSelector((state) => state.clientAppointment);
    const clientToken = localStorage.getItem("client_access_token");
    const [selectedDiscount, setSelectedDiscount] = useState(null);
    const [sortConfig, setSortConfig] = useState({ column: null, direction: "asc" });

    const sortedData = [...(Array.isArray(clientsAppointment) ? clientsAppointment : [])].sort((a, b) => {
  if (sortConfig.column === null) return 0;

  const key = sortConfig.column;
  const valA = a[key] ?? "";
  const valB = b[key] ?? "";

  if (!isNaN(valA) && !isNaN(valB)) {
    return sortConfig.direction === "asc"
      ? valA - valB
      : valB - valA;
  } else {
    return sortConfig.direction === "asc"
      ? valA.toString().localeCompare(valB.toString())
      : valB.toString().localeCompare(valA.toString());
  }
});

   const handleSort = (columnKey) => {
      let direction = "asc";
      if (sortConfig.column === columnKey && sortConfig.direction === "asc") {
         direction = "desc";
      }
      setSortConfig({ column: columnKey, direction });
   };

    const [form, setForm] = useState({
        appointment_date: "",
        start_time: "",
        end_time: "",
        description: "",
    });

    const handleFormChange = (e) => {
        const { name, value, files } = e.target;
        setForm((prev) => ({
        ...prev,
        [name]: files ? files[0] : value,
        }));
    };

    useEffect(() => {
        dispatch(getClientAppointmentList(clientToken));
    }, [dispatch]);

    // console.log("clientsAppointment", clientsAppointment);

    const [showAddModal, setShowAddModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);

    const handleAddBookAppointmentModel = () => {
        setForm({ 
            appointment_date: "",
            start_time: "",
            end_time: "",
            description: "",
        });
      setShowAddModal(true);
    };

    const handleCloseAddBookAppointmentModal = () => {
      setShowAddModal(false);
    };

    const convertTo12Hour = (time24) => {
        if (!time24) return "";
        const [hoursStr, minutes] = time24.split(":");
        const hours = parseInt(hoursStr, 10);
        const ampm = hours >= 12 ? "PM" : "AM";
        const hour12 = hours % 12 === 0 ? 12 : hours % 12;
        return `${hour12.toString().padStart(2, "0")}:${minutes} ${ampm}`;
    };

    const handleEditBookAppointmentModel = (appointment) => {
        setSelectedDiscount(appointment)
        setForm({ 
            appointment_date: appointment.appointment_date || "", 
            start_time: convertTo12Hour(appointment.start_time),
            end_time: convertTo12Hour(appointment.end_time),
            description: appointment.description || ""
        });
        setShowEditModal(true);
    };

    const handleCloseEditBookAppointmentModal = () => {
      setShowEditModal(false);
    };

    const generateTimeOptions = () => {
        const times = [];
        let hour = 0;
        let minute = 0;

        while (hour < 24) {
            const hour12 = hour % 12 === 0 ? 12 : hour % 12;
            const ampm = hour < 12 ? 'AM' : 'PM';
            const minStr = minute === 0 ? '00' : '30';
            const timeStr = `${hour12.toString().padStart(2, '0')}:${minStr} ${ampm}`;
            times.push(timeStr);

            // Increment by 30 minutes
            if (minute === 0) {
            minute = 30;
            } else {
            minute = 0;
            hour++;
            }
        }

        return times;
    };

    const timeOptions = generateTimeOptions();

    const handleUpdateSubmit = async () => {
        const formData = new FormData();
        formData.append("appointment_date", form.appointment_date);
        formData.append("start_time", form.start_time);
        formData.append("end_time", form.end_time);
        formData.append("description", form.description);
    
        const result = await dispatch(
            updateClientAppointment({
            token: clientToken,
            formData: formData,
            appointmentId: selectedDiscount.id,
            })
        );
    
        if (result.meta.requestStatus === "fulfilled") {
            toast.success("Apppointment updated successfully", {
            position: "top-right",
            autoClose: 2000,
            });
            handleCloseEditBookAppointmentModal();
            dispatch(getClientAppointmentList(clientToken)); // Refresh list
        } else {
            toast.error("Failed to update apppointment", {
            position: "top-right",
            autoClose: 2000,
            });
        }
    }

    const handleDeleteAppointment = async (appointmentId) => {
        const confirmed = window.confirm("Are you sure you want to delete this appointment?");
        if (!confirmed) return;
            
        const result = await dispatch(deleteClientAppointment({ token: clientToken, appointmentId }));
            
        if (result.meta.requestStatus === "fulfilled") {
            toast.success("Appointment deleted successfully", {
                position: "top-right",
                autoClose: 2000,
                style: { fontSize: "0.85rem" },
            });
                dispatch(getClientAppointmentList(clientToken)); // Refresh list
        } else {
            toast.error("Failed to delete appointment", {
                position: "top-right",
                autoClose: 2000,
                style: { fontSize: "0.85rem" },
            });
        }
    };

    return (
        <>
            {/* <div className="container mt-4">
                <div className="d-flex justify-content-between align-items-center">
                    <h2 className="mb-3">Book Appointment</h2>
                    <button className="btn btn-sm btn-primary" onClick={handleAddBookAppointmentModel}>Add Appointment</button>
                </div>
                <table className="table table-bordered">
                    <thead className="table-light">
                        <tr>
                        <th>Provider</th>
                        <th>Appointment Date</th>
                        <th>Start Time</th>
                        <th>End Time</th>
                        <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {Array.isArray(clientsAppointment) && clientsAppointment.length > 0 ? (
                            clientsAppointment.map((appointment) => (
                            <tr key={appointment.id}>
                                <td>{appointment.provider.company_name}</td>
                                <td>{appointment.appointment_date}</td>
                                <td>{appointment.start_time}</td>
                                <td>{appointment.end_time}</td>
                                <td>
                                <button
                                    className="btn btn-sm btn-primary me-2"
                                    onClick={() => handleEditBookAppointmentModel(appointment)}
                                >
                                    Edit
                                </button>
                                <button 
                                    className="btn btn-sm btn-danger"
                                    onClick={() => handleDeleteAppointment(appointment.id)}
                                >
                                    Delete
                                </button>
                                </td>
                            </tr>
                            ))
                        ) : (
                            <tr>
                            <td colSpan="5" className="text-center">No data found</td>
                            </tr>
                        )}
                    </tbody>
                </table>
                {showAddModal && (
                    <div className="modal fade show" style={{ display: "block" }} tabIndex="-1" aria-modal="true" role="dialog">
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Add Document</h5>
                                    <button type="button" className="btn-close" onClick={handleCloseAddBookAppointmentModal} aria-label="Close"></button>
                                </div>
                                <div className="modal-body">
                                    <form>
                                        <div className="mb-3">
                                            <label htmlFor="provider" className="form-label">
                                                Select Provider:
                                            </label>
                                            <select
                                                className="form-control"
                                                id="provider"
                                            >
                                                <option value="someOption">Some option</option>
                                                <option value="otherOption">Other option</option>
                                            </select>
                                        </div>
                                        <div className="mb-3">
                                            <label htmlFor="service" className="form-label">
                                                Select Service:
                                            </label>
                                            <select
                                                className="form-control"
                                                id="service"
                                            >
                                                <option value="someOption">Some option</option>
                                                <option value="otherOption">Other option</option>
                                            </select>
                                        </div>
                                        <div className="mb-3">
                                            <label htmlFor="appointment_date" className="form-label">
                                                Appointment Date:
                                            </label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                id="appointment_date"
                                            />
                                        </div>
                                        <div className="mb-3">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label htmlFor="start_time" className="form-label">
                                                        Start Time::
                                                    </label>
                                                    <select id="start_time" className="form-control">
                                                        {timeOptions.map((time, index) => (
                                                            <option key={index} value={time}>
                                                            {time}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>

                                                <div className="col-md-6">
                                                    <label htmlFor="end_time" className="form-label">
                                                        End Time:
                                                    </label>
                                                    <select id="end_time" className="form-control">
                                                        {timeOptions.map((time, index) => (
                                                            <option key={index} value={time}>
                                                            {time}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="mb-3">
                                            <label htmlFor="description" className="form-label">
                                                Description:
                                            </label>
                                            <textarea
                                                type="text"
                                                className="form-control"
                                                id="description"
                                            />
                                        </div>
                                    </form>
                                </div>
                                <div className="modal-footer">
                                    <button className="btn btn-secondary" onClick={handleCloseAddBookAppointmentModal}>Close</button>
                                    <button className="btn btn-primary" >Add</button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                {showEditModal && (
                    <div className="modal fade show" style={{ display: "block" }} tabIndex="-1" aria-modal="true" role="dialog">
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Edit Appointment</h5>
                                    <button type="button" className="btn-close" onClick={handleCloseEditBookAppointmentModal} aria-label="Close"></button>
                                </div>
                                <div className="modal-body">
                                    <form>
                                        <div className="mb-3">
                                            <label htmlFor="provider" className="form-label">
                                                Select Provider:
                                            </label>
                                            <select
                                                className="form-control"
                                                id="provider"
                                                disabled
                                            >
                                                <option value="someOption">Some option</option>
                                                <option value="otherOption">Other option</option>
                                            </select>
                                        </div>
                                        <div className="mb-3">
                                            <label htmlFor="service" className="form-label">
                                                Select Service:
                                            </label>
                                            <select
                                                className="form-control"
                                                id="service"
                                                disabled
                                            >
                                                <option value="someOption">Some option</option>
                                                <option value="otherOption">Other option</option>
                                            </select>
                                        </div>
                                        <div className="mb-3">
                                            <label htmlFor="appointment_date" className="form-label">
                                                Appointment Date:
                                            </label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                id="appointment_date"
                                                value={form.appointment_date}
                                                onChange={handleFormChange}
                                            />
                                        </div>
                                        <div className="mb-3">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label htmlFor="start_time" className="form-label">
                                                        Start Time::
                                                    </label>
                                                    <select 
                                                        id="start_time"
                                                        name="start_time"
                                                        className="form-control"
                                                        value={form.start_time}
                                                        onChange={handleFormChange}
                                                    >
                                                        {timeOptions.map((time, index) => (
                                                            <option key={index} value={time}>
                                                            {time}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>

                                                <div className="col-md-6">
                                                    <label htmlFor="end_time" className="form-label">
                                                        End Time:
                                                    </label>
                                                    <select
                                                        id="end_time"
                                                        name="end_time"
                                                        className="form-control"
                                                        value={form.end_time}
                                                        onChange={handleFormChange}
                                                    >
                                                        {timeOptions.map((time, index) => (
                                                            <option key={index} value={time}>
                                                            {time}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="mb-3">
                                            <label htmlFor="description" className="form-label">
                                                Description:
                                            </label>
                                            <textarea
                                                type="text"
                                                className="form-control"
                                                id="description"
                                                name="description"
                                                value={form.description}
                                                onChange={handleFormChange}
                                            />
                                        </div>
                                    </form>
                                </div>
                                <div className="modal-footer">
                                    <button className="btn btn-secondary" onClick={handleCloseEditBookAppointmentModal}>Close</button>
                                    <button className="btn btn-primary" onClick={handleUpdateSubmit}>Update</button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div> */}


            <div className="col-md-8 col-xl-9 mt-4 mt-md-0">
                <div className="ps-2 ps-lg-4">
                    <h4 className="font-weight-bold text-primary font-size-40 mb-4 pb-1 line-hight-2 border-bottom pb-3 montserrat d-flex">
                        My Appointments
                        {/* <button className="btn btn-danger ms-auto py-2" onClick={handleAddBookAppointmentModel}>
                            <i className="fa fa-user-plus me-1"></i> Add Appointment
                        </button> */}
                    </h4>
                        <div className="table-responsive">
                            <table className="table table-striped table-bordered align-middle" id="servicesTable">
              <thead>
                <tr>
                  <th className="font-weight-semibold" onClick={() => handleSort("provider")}>Provider <span className="d-grid table-grad"><i className="fa fa-sort-asc sort-icon"></i><i className="fa fa-sort-down sort-icon" style={{ marginTop: "-8px" }}></i></span></th>
                  <th className="font-weight-semibold" onClick={() => handleSort("service")}>Service <span className="d-grid table-grad"><i className="fa fa-sort-asc sort-icon"></i><i className="fa fa-sort-down sort-icon" style={{ marginTop: "-8px" }}></i></span></th>
                  <th className="font-weight-semibold" onClick={() => handleSort("start_date")}>Appointment Date <span className="d-grid table-grad"><i className="fa fa-sort-asc sort-icon"></i><i className="fa fa-sort-down sort-icon" style={{ marginTop: "-8px" }}></i></span></th>
                  <th className="font-weight-semibold" onClick={() => handleSort("start_time")}>Start Time <span className="d-grid table-grad"><i className="fa fa-sort-asc sort-icon"></i><i className="fa fa-sort-down sort-icon" style={{ marginTop: "-8px" }}></i></span></th>
                  <th className="font-weight-semibold" onClick={() => handleSort("end_time")}>End Time <span className="d-grid table-grad"><i className="fa fa-sort-asc sort-icon"></i><i className="fa fa-sort-down sort-icon" style={{ marginTop: "-8px" }}></i></span></th>
                  <th className="font-weight-semibold">Actions</th>
                </tr>
              </thead>
              <tbody>
                        {Array.isArray(sortedData) && sortedData.length > 0 ? (
                            sortedData.map((appointment) => (
                            <tr key={appointment.id}>
                                <td>{appointment.provider.company_name}</td>
                                <td>{appointment.services ? appointment.services.service_name : '-'}</td>
                                <td>{appointment.start_date}</td>
                                <td>{appointment.start_time}</td>
                                <td>{appointment.end_time}</td>
                                <td>
                                {/* <button
                                    className="btn text-primary p-1"
                                    onClick={() => handleEditBookAppointmentModel(appointment)}
                                >
                                    <i className="fa fa-pencil font-size-20"></i>
                                </button> */}
                                <button 
                                    className="btn btn-md text-danger me-1 p-1"
                                    onClick={() => handleDeleteAppointment(appointment.id)}
                                >
                                    <i className="fa fa-trash font-size-20"></i>
                                </button>
                                {(() => {
    const now = new Date(); // Current local datetime
    const appointmentDate = new Date(appointment.start_date); // Only date (local)

    // If appointment is today
    const isToday = appointmentDate.toDateString() === now.toDateString();

    // Combine appointment date and time
    const [hours, minutes] = appointment.start_time.split(':');
    const appointmentDateTime = new Date(appointmentDate);
    appointmentDateTime.setHours(+hours, +minutes, 0, 0); // Local time

    // If date is in the past, do nothing extra
    if (appointmentDate < new Date(now.toDateString())) {
      return null;
    }

    // Show "Join" if it's time and URL exists
    if (isToday && now >= appointmentDateTime && appointment.session_url) {
      return (
        <a
          href={appointment.session_url}
          className="btn btn-custom-primary"
          target="_blank"
          rel="noopener noreferrer"
        >
          Join
        </a>
      );
    }

    return null;
  })()}
                                </td>
                            </tr>
                            ))
                        ) : (
                            <tr>
                            <td colSpan="5" className="text-center">No data found</td>
                            </tr>
                        )}
                    </tbody>
                </table>
                        </div>
                    
                </div>
                {showAddModal && (
                    <div className="modal fade show" style={{ display: "block" }} tabIndex="-1" aria-modal="true" role="dialog">
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="font-weight-bold text-primary font-size-24 line-hight-2 montserrat d-flex">Add Appointment</h5>
                                    <button type="button" className="btn-close" onClick={handleCloseAddBookAppointmentModal} aria-label="Close"></button>
                                </div>
                                <div className="modal-body">
                                    <form>
                                        <div className="mb-3">
                                            <label htmlFor="provider" className="form-label text-primary mb-1 font-weight-semibold">
                                                Select Provider:
                                            </label>
                                            <select
                                                className="form-control"
                                                id="provider"
                                            >
                                                <option value="someOption">Some option</option>
                                                <option value="otherOption">Other option</option>
                                            </select>
                                        </div>
                                        <div className="mb-3">
                                            <label htmlFor="service" className="form-label text-primary mb-1 font-weight-semibold">
                                                Select Service:
                                            </label>
                                            <select
                                                className="form-select"
                                                id="service"
                                            >
                                                <option value="someOption">Some option</option>
                                                <option value="otherOption">Other option</option>
                                            </select>
                                        </div>
                                        <div className="mb-3">
                                            <label htmlFor="appointment_date" className="form-label text-primary mb-1 font-weight-semibold">
                                                Appointment Date:
                                            </label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                id="appointment_date"
                                            />
                                        </div>
                                        <div className="mb-3">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label htmlFor="start_time" className="form-label text-primary mb-1 font-weight-semibold">
                                                        Start Time::
                                                    </label>
                                                    <select id="start_time" className="form-control">
                                                        {timeOptions.map((time, index) => (
                                                            <option key={index} value={time}>
                                                            {time}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>

                                                <div className="col-md-6">
                                                    <label htmlFor="end_time" className="form-label text-primary mb-1 font-weight-semibold">
                                                        End Time:
                                                    </label>
                                                    <select id="end_time" className="form-control">
                                                        {timeOptions.map((time, index) => (
                                                            <option key={index} value={time}>
                                                            {time}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="mb-3">
                                            <label htmlFor="description" className="form-label text-primary mb-1 font-weight-semibold">
                                                Description:
                                            </label>
                                            <textarea
                                                type="text"
                                                className="form-control"
                                                id="description"
                                            />
                                        </div>
                                    </form>
                                </div>
                                <div className="modal-footer">
                                    <button className="btn btn-secondary font-weight-medium font-size-16 text-capitalize px-4 rounded m-1" onClick={handleCloseAddBookAppointmentModal}>Close</button>
                                    <button className="btn btn-custom-primary font-weight-medium font-size-16 text-capitalize px-4 rounded m-1" >Add</button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                {showEditModal && (
                    <div className="modal fade show" style={{ display: "block" }} tabIndex="-1" aria-modal="true" role="dialog">
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Edit Appointment</h5>
                                    <button type="button" className="btn-close" onClick={handleCloseEditBookAppointmentModal} aria-label="Close"></button>
                                </div>
                                <div className="modal-body">
                                    <form>
                                        <div className="mb-3">
                                            <label htmlFor="provider" className="form-label text-primary mb-1 font-weight-semibold">
                                                Select Provider:
                                            </label>
                                            <select
                                                className="form-control"
                                                id="provider"
                                                disabled
                                            >
                                                <option value="someOption">Some option</option>
                                                <option value="otherOption">Other option</option>
                                            </select>
                                        </div>
                                        <div className="mb-3">
                                            <label htmlFor="service" className="form-label text-primary mb-1 font-weight-semibold">
                                                Select Service:
                                            </label>
                                            <select
                                                className="form-control"
                                                id="service"
                                                disabled
                                            >
                                                <option value="someOption">Some option</option>
                                                <option value="otherOption">Other option</option>
                                            </select>
                                        </div>
                                        <div className="mb-3">
                                            <label htmlFor="appointment_date" className="form-label text-primary mb-1 font-weight-semibold">
                                                Appointment Date:
                                            </label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                id="appointment_date"
                                                value={form.appointment_date}
                                                onChange={handleFormChange}
                                            />
                                        </div>
                                        <div className="mb-3">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label htmlFor="start_time" className="form-label text-primary mb-1 font-weight-semibold">
                                                        Start Time::
                                                    </label>
                                                    <select 
                                                        id="start_time"
                                                        name="start_time"
                                                        className="form-control"
                                                        value={form.start_time}
                                                        onChange={handleFormChange}
                                                    >
                                                        {timeOptions.map((time, index) => (
                                                            <option key={index} value={time}>
                                                            {time}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>

                                                <div className="col-md-6">
                                                    <label htmlFor="end_time" className="form-label text-primary mb-1 font-weight-semibold">
                                                        End Time:
                                                    </label>
                                                    <select
                                                        id="end_time"
                                                        name="end_time"
                                                        className="form-control"
                                                        value={form.end_time}
                                                        onChange={handleFormChange}
                                                    >
                                                        {timeOptions.map((time, index) => (
                                                            <option key={index} value={time}>
                                                            {time}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="mb-3">
                                            <label htmlFor="description" className="form-label text-primary mb-1 font-weight-semibold">
                                                Description:
                                            </label>
                                            <textarea
                                                type="text"
                                                className="form-control"
                                                id="description"
                                                name="description"
                                                value={form.description}
                                                onChange={handleFormChange}
                                            />
                                        </div>
                                    </form>
                                </div>
                                <div className="modal-footer">
                                    <button className="btn btn-secondary font-weight-medium font-size-16 text-capitalize px-4 rounded m-1" onClick={handleCloseEditBookAppointmentModal}>Close</button>
                                    <button className="btn btn-custom-primary font-weight-medium font-size-16 text-capitalize px-4 rounded m-1" onClick={handleUpdateSubmit}>Update</button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export default ClientBookAppointment;